/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PearsonTemplatePermissionsParser = 
/* #__PURE__ */ parsers.object([['manage', codecBoolean]]);
export class PearsonTemplatePermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PearsonTemplatePermissionsParser.decode(input).map(res => new PearsonTemplatePermissions(res));
    }
    static unsafeDecode(input) {
        return PearsonTemplatePermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PearsonTemplatePermissionsParser.encode(data);
    }
    static schema() {
        return PearsonTemplatePermissionsParser.schema();
    }
}
